import { ConfirmationDialog } from "../../../assets/types/common";
import { Constants } from "../../../assets/utils/lib/constants";
import { LoadingIndicator } from "../../../assets/vfx";
import Drawer from "../../../assets/vfx/drawer/drawer";
import { BannerDto } from "../../../services/dto";
import { LookupDto } from "../../../assets/utils/lib/lookupDto";
import DisplayData from "../../common/DisplayData/DisplayData";
import { FormatHelper } from "../../../assets/utils/helpers/formatHelper";
import { BannerService } from "./bannerService";

interface BannerViewProps {
  data: BannerDto | undefined;
  show: boolean;
  onHide: () => void;
  onEdit: () => void;
  onDelete: () => void;
}

export const BannerView = (props: BannerViewProps) => {
  const bannerLocationQuery = BannerService.getBannerLocationLookups(
    props.data?.communityId
  );
  const LocationData: string[] = props.data?.locations
    ? (props.data.locations
        .map(
          (location) =>
            LookupDto.getLookupById(bannerLocationQuery.data, location)
              ?.display
        )
        .filter(Boolean) as string[])
    : [];

  return (
    <Drawer.View
      className="w-30"
      show={props.show}
      backdrop
      placement="end"
      scroll
      title={"View Banner"}
      modalDialogProps={
        !props.data?.isDeleted
          ? new ConfirmationDialog().get(props.onDelete, "Delete", {
              Name: props.data?.name ?? Constants.emptyString,
            })
          : undefined
      }
      onHide={props.onHide}
      onEdit={props.onEdit}
      onDelete={!props.data?.isDeleted ? props.onDelete : undefined}
    >
      {!props.data ? (
        <LoadingIndicator isFullPage />
      ) : (
        <>
          {props.data.image && (
            <DisplayData
              text="Banner"
              importedData={props.data.image}
              imageStyle={{
                width: 220,
                height: "auto",
                objectFit: "contain",
                border: "1px solid #ccc",
                borderRadius: 4,
              }}
            />
          )}
          <DisplayData text="Name" importedData={props.data.name} />
          {props.data.description && (
            <DisplayData
              text="Description"
              importedData={props.data.description}
            />
          )}
          {LocationData && LocationData.length > 0 && (
            <DisplayData text="Areas" importedData={LocationData} isBubble />
          )}
          {props.data.url && (
            <DisplayData text="Url" importedData={props.data.url} />
          )}
          {props.data.startDate && (
            <DisplayData
              text="Start date"
              importedData={FormatHelper.formatDate(props.data.startDate)}
            />
          )}
          {props.data.endDate && (
            <DisplayData
              text="End date"
              importedData={FormatHelper.formatDate(props.data.endDate)}
            />
          )}
        </>
      )}
    </Drawer.View>
  );
};
